import moment from 'moment';

export var landlordReducer = (state = null, action) => {
	switch(action.type) {
		case "GET_LANDLORD": 
			return action.landlord;
		case "RESTORE_LANDLORD" : 
			if (state && state.id === action.id) {
				return {...state, updated_at: moment().format("YYYY-MM-DD hh:mm:ss"), deleted_at: null};
			}
			return state;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/landlordReducer.js